import EntityBadge from '../Badges/EntityBadge'

const LABEL_STYLE = { gap: 5 }

/**
 * The dropdown option of an entity selector : its category badge, then its label. The entities are
 * listed flat and sorted by category, so the badge is all that is needed to tell the groups apart.
 */
const EntityOptionLabel = ({ entity, label }) => (
  <span className='flex-row ai-ctr' style={LABEL_STYLE}>
    <EntityBadge entity={entity} size='sm' />
    {label}
  </span>
)

export default EntityOptionLabel
